import { call, put, select, takeLatest } from "redux-saga/effects";
import { getType } from "typesafe-actions";
import { createResourceActions, resourceActions, resourcesActions, updateResourceActions } from "./resources.actions";
import { createResourceApi, getResourceApi, getResourcesApi, updateResourceApi } from "./resources.api";
import { ResourceDto } from "./resources.dtos";

function* setResources(result: ResourceDto[], newItems: ResourceDto[]) {
    result.forEach(i => {
      let oldItemIndex = newItems.findIndex(s => s.id === i.id);
      if (oldItemIndex === -1) newItems.push(i);
      else newItems[oldItemIndex] = i;
    }); 
    yield put({ type: getType(resourcesActions.success), payload: newItems });
    sessionStorage.setItem(`resources`, JSON.stringify(newItems));
}

function* handleGetResources(request: ReturnType<typeof resourcesActions.request>) {
    const storeList: ResourceDto[] = yield select(state => state.resources.list);
    const resourceStorage = sessionStorage.getItem(`resources`);
    const sessionResources = resourceStorage === null ? [] : JSON.parse(resourceStorage) as ResourceDto[];
    const resources: ResourceDto[] = 
    // storeList !== undefined && storeList.length !== 0 ? storeList :
    //   sessionResources.length !== 0 ? sessionResources :
        yield call(getResourcesApi);
  
    yield put({ type: getType(resourcesActions.success), payload: resources });
    sessionStorage.setItem(`resources`, JSON.stringify(resources));
}

function* handleGetResource(request: ReturnType<typeof resourceActions.request>) {
    const storeResource: ResourceDto = yield select(state => state.resources.resource);
    const resource: ResourceDto = (storeResource !== undefined && storeResource.id !== undefined && storeResource.id === request.payload) ? storeResource : yield call(getResourceApi, request.payload);
  
    yield put({ type: getType(resourceActions.success), payload: resource });
  }

function* handleUpdateResource(request: ReturnType<typeof updateResourceActions.request>) {
    const storeList = yield select(state => state.resources.list);
    const updatedResource: ResourceDto = yield call(updateResourceApi, request.payload);
  
    yield put({ type: getType(resourceActions.success), payload: updatedResource });
  
    if (storeList !== undefined && storeList.length !== 0)
      yield setResources([updatedResource], JSON.parse(JSON.stringify(storeList)) as ResourceDto[]);
}
  
function* handleCreateResource(request: ReturnType<typeof createResourceActions.request>) {
    const storeList = yield select(state => state.resources.list);
    const createdResource: ResourceDto = yield call(createResourceApi, request.payload);
  
    yield put({ type: getType(resourceActions.success), payload: createdResource });
  
    if (storeList !== undefined && storeList.length !== 0)
      yield setResources([createdResource], JSON.parse(JSON.stringify(storeList)) as ResourceDto[]);
}

export function* watchGetResourcesRequest() {
    try {
      yield takeLatest(getType(resourcesActions.request), handleGetResources);
    }
    catch (err) {
      console.log(err);
    }
}

export function* watchGetResourceRequest() {
    try {
      yield takeLatest(getType(resourceActions.request), handleGetResource);
    }
    catch (err) {
      console.log(err);
    }
}

export function* watchUpdateResourceRequest() {
    try {
      yield takeLatest(getType(updateResourceActions.request), handleUpdateResource);
    }
    catch (err) {
      console.log(err);
    }
}
  
export function* watchCreateResourceRequest() {
    try {
      yield takeLatest(getType(createResourceActions.request), handleCreateResource);
    }
    catch (err) {
      console.log(err);
    }
}